/**
 * ENUM Status de um documento.
 */
export enum DocumentStatusEnum {
    AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
    SIGNED = 'SIGNED',
    DECLINED = 'DECLINED',
}
